<template>
    <div style="width: 90%;">
        <div v-if="!init" class="row d-flex justify-content-center align-items-center">
            <div class="spinner-border text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <template v-else>
            <div class="row">
<!--                <div class="col-4 font-weight-bold pb-3 pt-2">Ім'я датчика:</div>-->
                <div class="col-12"><h3 class="text-center">{{ deviceName }}</h3></div>
            </div>
            <!--            <div class="row pb-2">-->
            <!--                <div class="col-4 font-weight-bold pb-2">Тип датчика:</div>-->
            <!--                <div class="col-8">{{ device.type }}</div>-->
            <!--            </div>-->
            <div class="row pb-3">
                <div class="col-12">
                    <div class="btn-group btn-group-sm btn-block" role="group" aria-label="Basic example">
                        <button @click="currentTab = 'temperature'" :class="{ active : currentTab === 'temperature' }" class="btn btn-outline-danger"><small>℃</small></button>
                        <!--                        <button @click="currentTab = 'humidity'" :class="{ active : currentTab === 'humidity' }" class="btn btn-outline-danger"><small>Вологість</small></button>-->
                        <!--                        <button @click="currentTab = 'pressure'" :class="{ active : currentTab === 'pressure' }" class="btn btn-outline-danger"><small>Тиск</small></button>-->
                        <button @click="currentTab = 'PM25'" :class="{ active : currentTab === 'PM25' }" class="btn btn-outline-danger"><small>PM 2.5</small></button>
                        <button @click="currentTab = 'PM10'" :class="{ active : currentTab === 'PM10' }" class="btn btn-outline-danger"><small>PM 10</small></button>
                        <button @click="currentTab = 'CO2'" :class="{ active : currentTab === 'CO2' }" class="btn btn-outline-danger"><small>CO2</small></button>
                    </div>
                </div>
            </div>
            <div v-if="chartData" class="row pb-0">
                <div class="col-12">
                    <div class="alert alert-success">
                        {{ currentLastLabel }}: <strong>{{ currentLastValue }}</strong>
                    </div>
                </div>
            </div>
            <div class="row pb-3">
                <div v-if="chartData" class="col-12">
                    <BarChart style="height: 150px; width: 100%;" :chart-data="chartData" :options="options"/>
                </div>
                <div v-else class="col-12 d-flex justify-content-center align-items-center" style="height: 355px;">
                    <h5 class="text-muted text-center">Дані відсутні</h5>
                </div>
            </div>

            <Aqi v-if="chartData" :devEUI="device.devEUI" :last24HoursStat="devStat"/>

            <div class="row">
                <div class="col-6">
                    <Messengers :devBots="botDevice"/>
                </div>
                <div class="col-6">
                    <button v-if="localityButton !== false" @click="goToDetailsPage" class="btn btn-outline-info btn-block">Детальніше</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import BarChart from "./BarChart";
import moment from "moment-mini";
import StatService from "@/services/StatService";
import Messengers from "./Messengers";
import Aqi from "@/components/Aqi";
import _ from "underscore";

export default {
    name: "MapPopup",
    components: {
        BarChart,
        Messengers,
        Aqi
    },
    props: ["device", "botDevice", "router", "localityButton"],
    data() {
        return {
            devStat: null,
            data: [],
            init: false,
            currentTab: "temperature",
            tabs: {
                temperature: "Температура повітря (℃)",
                humidity: "Відносна вологість (%)",
                PM25: "Концентрація частинок пилу PM 2.5 (мкг/м³)",
                PM10: "Концентрація частинок пилу PM 10 (мкг/м³)",
                CO2: "Концентрація CO2 (ppm)",
                pressure: "Атмосферний тиск (мм. рт. ст)",
            },
            colors: {
                temperature: "#4CB051",
                humidity: "#EB1E63",
                PM25: "#2196F3",
                PM10: "#663BB7",
                CO2: "#FEC106",
                pressure: "#01BCD6",
            },
            backgrounds: {
                temperature: "rgba(76,176,81,0.5)",
                humidity: "rgba(235,30,99,0.5)",
                PM25: "rgba(33,150,243,0.5)",
                PM10: "rgba(102,59,183,0.5)",
                CO2: "rgba(254,193,6,0.5)",
                pressure: "rgba(1,188,214,0.5)",
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    labels: {
                        boxWidth: 0,
                    }
                },
                scales: {
                    xAxes: [{
                        barPercentage: 0.9,
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                            fontSize: 9
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                            suggestedMin: 0,
                            fontSize: 9
                        }
                    }]
                }
            },
        }
    },
    methods: {
        goToDetailsPage() {
            this.router.push({
                name: 'Locality', query: {
                    deveui: this?.device?.devEUI
                }
            });
        }
    },
    computed: {
        deviceName() {
            return this.botDevice?.name || this.device?.name;
        },
        chartData() {
            var self = this;

            if (!self.data || !self.init) {
                return {};
            }


            var data = self.data.map(function (item) {

                // паскали в мм. рт. ст.
                if (self.currentTab === 'pressure') {
                    return {
                        value: ((item[self.currentTab] * 10) / 133.3224).toFixed(0),
                        datetime: moment(item.datetime).format("HH:mm")
                    };
                }

                return {
                    value: item[self.currentTab],
                    datetime: moment(item.datetime).format("HH:mm")
                };
            });

            var labels = data.map(function (item) {
                return item.datetime;
            });


            var isEmptyChart = _.some(data.map(item => item.value), item => {
                return item === 0;
            })

            if (isEmptyChart) {
                return false;
            }

            return {
                labels: labels,
                datasets: [{
                    label: self.tabs[self.currentTab],
                    backgroundColor: self.backgrounds[self.currentTab],
                    borderColor: self.colors[self.currentTab],
                    data: data.map(item => item.value),
                    pointRadius: 0,
                    borderWidth: 0
                }]
            }
        },
        currentLastLabel() {
            let firstWord = this.currentTab == 'pressure' ? "Поточний " : "Поточна ";
            let str = this.tabs[this.currentTab];
            return firstWord + str.charAt(0).toLowerCase() + str.slice(1);
        },
        currentLastValue() {
            if (!this.chartData) {
                return 0;
            }

            let data = this.chartData.datasets[0].data.slice();
            return data.reverse()[0];
        },
    },
    async mounted() {
        const start = moment().format("YYYY-MM-DD");
        const stop = moment().subtract(1, 'days').format("YYYY-MM-DD");
        this.devStat = await (new StatService()).getDeviceStat(this.device.devEUI, start, stop);

        this.data = this.devStat.data.slice(0, 10).reverse();

        setTimeout(() => {
            this.init = true;
        }, 400);
    },
}
</script>

<style scoped>

</style>